export default "__VITE_PUBLIC_ASSET__64012e5d__"